$(document).ready(function () {
  //collection page sale text

  setTimeout(function () {
   
    $(".cstm-productpercentage_off_collection").each(function () {
      if ($(this).html() === "") {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  }, 2500);
  setTimeout(function () {
    $(".pt-filter-drawer").show();
  }, 10);
  function initializeProductSlider() {
    if (window.matchMedia("(min-width: 749px)").matches) {
      $(".product__thumbs__holder").slick({
        vertical: true,
        verticalSwiping: true,
        infinite: false,
        slidesToShow: 4.3,
        slidesToScroll: 1,
        arrows: true,
        prevArrow:
          '<button class="slide-arrow prev-arrow"><img src="https://cdn.shopify.com/s/files/1/1898/0441/t/127/assets/up.svg" alt="Previous Image" role="presentation"></button>',
        nextArrow:
          '<button class="slide-arrow next-arrow"><img src="https://cdn.shopify.com/s/files/1/1898/0441/t/127/assets/down-arrow.svg" alt="Next Image"></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
              infinite: false,
              dots: false,
            },
          },
        ],
      });
    }
  }
  setTimeout(function () {
    initializeProductSlider();
  }, 1000);

  setTimeout(function () {
    $(".selector-wrapper__scrollbar").each(function () {
      $(this)
        .find(".swatches")
        .each(function (i) {
          if (i === 0) {
            var collSwatch = $(this)
              .data("swatch-variant-name")
              .split(" / ")[0]
              .trim()
              .toLowerCase();

            $(this)
              .parents(".product-item__info")
              .find(".collection__product--singlevariants .availabe_variant")
              .each(function () {
                var optionTitle = $(this)
                  .attr("option_title")
                  .split(" / ")[0]
                  .trim()
                  .toLowerCase();

                if (optionTitle === collSwatch) {
                  var salePercent =
                    $(this).attr("sale_percent_off")?.trim() || "0";

                  $(this)
                    .parents(".product-item__info")
                    .find(".cstm_percentage_off_collection")
                    .text(salePercent);

                  return false;
                }
              });
          }
        });
    });
  }, 2000);

  setTimeout(function () {
    $(".selector-wrapper__scrollbar").each(function () {
      $(this)
        .find(".swatches")
        .click(function () {
          var coll_swatch = $(this)
            .data("swatch-variant-name")
            .split(" / ")[0]
            .trim()
            .toLowerCase();

          $(this)
            .parents(".product-item__info")
            .find(".collection__product--singlevariants .availabe_variant")
            .each(function () {
              var option_title = $(this)
                .attr("option_title")
                .split(" / ")[0]
                .trim()
                .toLowerCase();

              if (option_title === coll_swatch) {
                var sale_percent = $(this).attr("sale_percent_off").trim(" ");

                $(this)
                  .parents(".product-item__info")
                  .find(".cstm_percentage_off_collection")
                  .text(sale_percent);
                return false;
              }
            });
        });
    });
  }, 2000);
  //end
  //produc sale text

  $(".swatches.swatch__button").click(function () {
    var product_swatch_sale = $(this)
      .attr("data-tooltip")
      .split(" / ")[0]
      .trim()
      .toLowerCase();

    $(".product-single__variants .select_product_sale_text").each(function () {
      var data_sale = $(this)
        .attr("option_title")
        .split(" / ")[0]
        .trim()
        .toLowerCase();

      if (product_swatch_sale === data_sale) {
        var sale_text = $(this).attr("sale_percent_off").trim();
        $(this)
          .parents(".product__block--lines")
          .siblings(".product__block.block-padding")
          .find(".cstm-productpercentage_off_collection")
          .text(sale_text);
        return false;
      }
    });
    $(".cstm-productpercentage_off_collection").each(function () {
      if ($(this).html() === "") {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  });

  setTimeout(function () {
    var load_text = $(".is-label-active")
      .parents(".swatches.swatch__button")
      .attr("data-tooltip")
      .split(" / ")[0]
      .trim()
      .toLowerCase();

    $(".product-single__variants .select_product_sale_text").each(function () {
      var data_sale = $(this)
        .attr("option_title")
        .split(" / ")[0]
        .trim()
        .toLowerCase();

      if (load_text === data_sale) {
        var sale_text = $(this).attr("sale_percent_off").trim();
        $(this)
          .parents(".product__block--lines")
          .siblings(".product__block.block-padding")
          .find(".cstm-productpercentage_off_collection")
          .text(sale_text);
        return false;
      }
    });
  }, 2200);
  //end

  //popup thumbnail image start
  $(".pswp__thumb.image-wrapper").hide();
  $(".image-wrapper").click(function () {
    setTimeout(function () {
      $(".pswp__thumb.image-wrapper").each(function () {
        $(this).hide();
      });
    }, 600);
  });

  //end

  //remove media--hidden class

  $("body").on("click", "radio-swatch.swatches.swatch__button", function () {
    $(
      ".product__slide.csmt_hide--productslider.media--active.media--hidden"
    ).removeClass("media--hidden");
    setTimeout(function () {
      const productSlideDiv = document.querySelector(
        ".media--active.media--hidden"
      );
      if (productSlideDiv) {
        productSlideDiv.classList.remove("media--hidden");
      }
    }, 500);
  });

  $("body").on("click", "radio-swatch.swatches.swatch__button", function () {
    setTimeout(function () {
      const productSlideDiv = document.querySelector(".media--active");

      if (productSlideDiv) {
        const allSlides = document.querySelectorAll(
          ".product__slide.csmt_hide--productslider"
        );
        allSlides.forEach((slide) => {
          if (!slide.classList.contains("media--active")) {
            slide.classList.add("media--hidden");
          }
        });
      }
      $(".csmt_hide--productslider:first")
        .addClass("media--active")
        .removeClass("media--hidden")
        .removeClass("media--hiding");
    }, 700);
  });

  var originalSrcset = {};
  $(".flickity-slider").each(function () {
    originalSrcset[$(this).attr("class")] = {};

    $(this)
      .find(".product-item__bg__inner1")
      .each(function () {
        var $img = $(this).find("img");
        var altText = $(this).attr("data-image-alt");
        var srcset = $img.attr("srcset");

        if (
          !originalSrcset[$(this).closest(".flickity-slider").attr("class")][
            altText
          ]
        ) {
          originalSrcset[$(this).closest(".flickity-slider").attr("class")][
            altText
          ] = {};
        }
        originalSrcset[$(this).closest(".flickity-slider").attr("class")][
          altText
        ][$(this).attr("data-index")] = srcset;
      });
  });

  $(".flickity-slider").each(function () {
    $(this)
      .find(".product-item__bg__inner1")
      .on("mouseover", function () {
        var $this = $(this);
        var currentAltText = $this.attr("data-image-alt");
        var currentIndex = $this.attr("data-index");
        var $img = $this.find("img");

        var foundSrcset = "";

        $(this)
          .siblings(".product-item__bg__inner1")
          .each(function () {
            if (
              $(this).attr("data-image-alt") === currentAltText &&
              $(this).attr("data-index") !== currentIndex &&
              $(this).attr("data-index") > parseInt(currentIndex) &&
              $(this).css("display") !== "none"
            ) {
              foundSrcset = $(this).find("img").attr("srcset");
              return false;
            }
          });

        if (foundSrcset && !$img.data("original-srcset")) {
          $img.data("original-srcset", $img.attr("srcset"));
          $img.attr("srcset", foundSrcset);
        }
      })
      .on("mouseout", function () {
        var $img = $(this).find("img");
        if ($img.data("original-srcset")) {
          $img.attr("srcset", $img.data("original-srcset"));
          $img.removeData("original-srcset");
        }
      });
  });

  //product hover code end

  //for select for size
  $(".radio__button").click(function () {
    $(".cstm-default_msg.cstm-red").hide();
  });
  //end

  //
  setTimeout(function () {
    $(".collection-item__info").each(function () {
      $(this).removeClass("aos-animate");
    });
  }, 1000);
  //

  var htmlContent = $(".product__slides").html();
  var thumbContent = $(".product__thumbs").html();
  setTimeout(function () {
    var Colorname = $(".is-label-active").attr("data-swatch");

    $(".product__thumb img").each(function () {
      var Imagealt = $(this).attr("alt");

      if (Imagealt.includes(",")) {
        var splitImagealt1 = Imagealt.split(",")[0];
        var splitImagealt = splitImagealt1.split("color=")[1];
      } else {
        var splitImagealt = Imagealt.split("color=")[1];
      }

      if (Colorname == splitImagealt) {
        $(this).parents(".product__thumb").show();
      } else {
        $(this).parents(".product__thumb").remove();
      }
    });

    $(".product__slide .product__photo").each(function () {
      var Imagealt1 = $(this).find("img").attr("alt");
      if (Imagealt1.includes(",")) {
        var splitImagealt1 = Imagealt1.split(",")[0];
        var splitImagealt = splitImagealt1.split("color=")[1];
      } else {
        var splitImagealt = Imagealt1.split("color=")[1];
      }
      if (Colorname == splitImagealt) {
        $(this)
          .parent(".product__slide ")
          .show()
          .addClass("csmt_hide--productslider");
      } else {
        $(this)
          .parent(".product__slide ")
          .hide()
          .removeClass("csmt_hide--productslider");
      }
    });
  }, 500);

  setTimeout(function () {
    var count = 0;
    var ttl = $(".csmt_hide--productslider").length;
    var startX;
    var endX;
    var isDragging = false;
    var threshold = 50; // Threshold for swipe detection

    // Function to update slides based on the current count
    function updateSlides() {
      $(".csmt_hide--productslider").each(function (i) {
        if (i === count) {
          $(this)
            .addClass("media--active")
            .removeClass("media--hidden")
            .removeClass("media--hiding");
        } else {
          $(this).removeClass("media--active").addClass("media--hidden");
        }
      });

      $(".product__thumb").each(function (index) {
        if (index === count) {
          $(this).addClass("is-active");
        } else {
          $(this).removeClass("is-active");
        }
      });
    }

    // Function to handle slide changes and wrap around if needed
    function changeSlide(direction) {
      if (direction === "next") {
        count++;
        if (count >= ttl) {
          count = 0;
        }
      } else if (direction === "prev") {
        count--;
        if (count < 0) {
          count = ttl - 1;
        }
      }
      updateSlides();
    }

    // Handle drag events
    function handleDrag() {
      if (typeof startX !== "undefined") {
        var deltaX = endX - startX;

        if (Math.abs(deltaX) > threshold) {
          if (deltaX < 0) {
            changeSlide("next");
          } else {
            changeSlide("prev");
          }
        }

        startX = undefined;
      }
    }

    $(document).on("mousedown", ".csmt_hide--productslider", function (e) {
      startX = e.pageX;
      isDragging = true;
    });

    $(document).on("mousemove", function (e) {
      if (isDragging) {
        endX = e.pageX;
      }
    });

    $(document).on("mouseup", function (e) {
      if (isDragging) {
        endX = e.pageX;
        handleDrag();
        isDragging = false;
      }
    });

    $(document).on("touchstart", ".csmt_hide--productslider", function (e) {
      var touch = e.originalEvent.touches[0];
      startX = touch.pageX;
      isDragging = true;
    });

    $(document).on("touchmove", function (e) {
      if (isDragging) {
        var touch = e.originalEvent.touches[0];
        endX = touch.pageX;
      }
    });

    $(document).on("touchend", function (e) {
      if (isDragging) {
        var touch = e.originalEvent.changedTouches[0];
        endX = touch.pageX;
        handleDrag();
        isDragging = false;
      }
    });

    // Handle click events for next and previous buttons
    $(".slider__button--next").click(function () {
      changeSlide("next");
    });

    $(".slider__button--prev").click(function () {
      changeSlide("prev");
    });
    updateSlides();
    if (window.matchMedia("(min-width: 749px)").matches) {
      $(".product__thumb").click(function (e) {
        e.preventDefault();

        $(".product__thumb").removeClass("is-active");
        $(this).addClass("is-active");
        var thumbIndex = $(this).parents(".slick-slide").index();

        $(".csmt_hide--productslider").each(function (index) {
          if (index === thumbIndex) {
            $(this).addClass("media--active").removeClass("media--hidden");
          } else {
            $(this).addClass("media--hidden").removeClass("media--active");
          }
        });
      });
    }
    if (window.matchMedia("(max-width: 748px)").matches) {
      $(".product__thumb").click(function (e) {
        e.preventDefault();

        $(".product__thumb").removeClass("is-active");
        $(this).addClass("is-active");
        var thumbIndex = $(this).index();

        $(".csmt_hide--productslider").each(function (index) {
          if (index === thumbIndex) {
            $(this).addClass("media--active").removeClass("media--hidden");
          } else {
            $(this).addClass("media--hidden").removeClass("media--active");
          }
        });
      });
    }
  }, 520);

  $("body").on("click", "radio-swatch.swatches.swatch__button", function () {

    $(".product__thumbs").html(thumbContent);
    $(".product__slide").removeClass("media--active");
    var Colorname = $(this).find("input").val();

    $(".product__thumb img").each(function () {
      var Imagealt = $(this).attr("alt");

      if (Imagealt.includes(",")) {
        var splitImagealt1 = Imagealt.split(",")[0];
        var splitImagealt = splitImagealt1.split("color=")[1];
      } else {
        var splitImagealt = Imagealt.split("color=")[1];
      }

      if (Colorname == splitImagealt) {
        $(this).parents(".product__thumb").show();
      } else {
        $(this).parents(".product__thumb").remove();
      }
    });

    $(".product__slide .product__photo").each(function () {
      var Imagealt1 = $(this).find("img").attr("alt");
      if (Imagealt1.includes(",")) {
        var splitImagealt1 = Imagealt1.split(",")[0];
        var splitImagealt = splitImagealt1.split("color=")[1];
      } else {
        var splitImagealt = Imagealt1.split("color=")[1];
      }
      if (Colorname == splitImagealt) {
        $(this)
          .parent(".product__slide ")
          .show()
          .addClass("csmt_hide--productslider")
          .removeClass("media--active");
      } else {
        $(this)
          .parent(".product__slide ")
          .hide()
          .removeClass("csmt_hide--productslider");
      }
    });

    setTimeout(function () {
      $(".product__thumb").each(function (i) {
        if ($(this).hasClass("is-active")) {
          if (parseInt(i) > 0) {
            setTimeout(function () {
              $(".csmt_hide--productslider")
                .removeClass("media--active")
                .addClass("media--hidden");
              $(".media--active").removeClass("media--hidden");
            }, 110);

            setTimeout(function () {
              $(".csmt_hide--productslider:first")
                .addClass("media--active")
                .removeClass("media--hidden");
              $(".media--active").removeClass("media--hidden");
            }, 120);

            return false;
          }
        }
      });
    }, 100);

    setTimeout(function () {
      const productSlideDiv = document.querySelector(
        ".product__slide.media--hidden"
      );
      if (productSlideDiv) {
        productSlideDiv.classList.remove("media--hidden");
      }
    }, 200);

    document.addEventListener("DOMContentLoaded", function () {
      const productSlideDiv = document.querySelector(
        ".product__slide.media--hidden"
      );
      if (productSlideDiv) {
        productSlideDiv.classList.remove("media--hidden");
      }
    });

    setTimeout(function () {
      const productSlideDivs = document.querySelectorAll(".product__thumb");

      if (productSlideDivs.length > 0) {
        productSlideDivs.forEach((div) => {
          div.classList.remove("is-active");
          productSlideDivs[0].classList.add("is-active");
        });
      }
    }, 410);

    $(".media--active").removeClass("media--hidden");

    var count = 0;
    var ttl = $(".csmt_hide--productslider").length;
    var startX;
    var endX;
    var isDragging = false;
    var threshold = 50;

    function updateSlides() {
      $(".csmt_hide--productslider").each(function (i) {
        if (i === count) {
          $(this)
            .addClass("media--active")
            .removeClass("media--hidden")
            .removeClass("media--hiding");
        } else {
          $(this).removeClass("media--active").addClass("media--hidden");
        }
      });

      $(".product__thumb").each(function (index) {
        if (index === count) {
          $(this).addClass("is-active");
        } else {
          $(this).removeClass("is-active");
        }
      });
    }

    function changeSlide(direction) {
      if (direction === "next") {
        count++;
        if (count >= ttl) {
          count = 0;
        }
      } else if (direction === "prev") {
        count--;
        if (count < 0) {
          count = ttl - 1;
        }
      }
      updateSlides();
    }

    function handleDrag() {
      if (typeof startX !== "undefined") {
        var deltaX = endX - startX;

        if (Math.abs(deltaX) > threshold) {
          if (deltaX < 0) {
            changeSlide("next");
          } else {
            changeSlide("prev");
          }
        }

        startX = undefined;
      }
    }

    $(document).on("mousedown", ".csmt_hide--productslider", function (e) {
      startX = e.pageX;
      isDragging = true;
    });

    $(document).on("mousemove", function (e) {
      if (isDragging) {
        endX = e.pageX;
      }
    });

    $(document).on("mouseup", function (e) {
      if (isDragging) {
        endX = e.pageX;
        handleDrag();
        isDragging = false;
      }
    });

    $(document).on("touchstart", ".csmt_hide--productslider", function (e) {
      var touch = e.originalEvent.touches[0];
      startX = touch.pageX;
      isDragging = true;
    });

    $(document).on("touchmove", function (e) {
      if (isDragging) {
        var touch = e.originalEvent.touches[0];
        endX = touch.pageX;
      }
    });

    $(document).on("touchend", function (e) {
      if (isDragging) {
        var touch = e.originalEvent.changedTouches[0];
        endX = touch.pageX;
        handleDrag();
        isDragging = false;
      }
    });

    $(".slider__button--next").click(function () {
      changeSlide("next");
    });

    $(".slider__button--prev").click(function () {
      changeSlide("prev");
    });

    updateSlides();
    if (window.matchMedia("(min-width: 749px)").matches) {
      $(".product__thumb").click(function (e) {
        e.preventDefault();

        $(".product__thumb").removeClass("is-active");
        $(this).addClass("is-active");
        var thumbIndex = $(this).parents(".slick-slide").index();

        $(".csmt_hide--productslider").each(function (index) {
          if (index === thumbIndex) {
            $(this).addClass("media--active").removeClass("media--hidden");
          } else {
            $(this).addClass("media--hidden").removeClass("media--active");
          }
        });
      });
    }
    if (window.matchMedia("(max-width: 748px)").matches) {
      $(".product__thumb").click(function (e) {
        e.preventDefault();

        $(".product__thumb").removeClass("is-active");
        $(this).addClass("is-active");
        var thumbIndex = $(this).index();

        $(".csmt_hide--productslider").each(function (index) {
          if (index === thumbIndex) {
            $(this).addClass("media--active").removeClass("media--hidden");
          } else {
            $(this).addClass("media--hidden").removeClass("media--active");
          }
        });
      });
    }
  });

  $(".swatches.swatch__button label").click(function () {
    var swatch_color = $(this).attr("data-swatch");
    var newsize = "";
    $(".radio__button input:checked").each(function () {
      var opt_size = $(this).val();
      newsize = opt_size;
      return false;
    });
    var concat_text = swatch_color + " / " + newsize;
    $(".cstm_pro_var--id").each(function () {
      var variant_option = $(this).attr("variant_att");

      if (variant_option == concat_text) {
        $(this).removeClass("hide-outofstock").addClass("showproduct");
      } else {
        $(this).addClass("hide-outofstock").removeClass("showproduct");
      }
    });
  });

  //on size click
  $(".radio__button input").click(function () {
    var opt_size = $(this).val();

    var newcolor = "";
    $(".swatch__button input:checked").each(function () {
      var opt_color = $(this).val();
      newcolor = opt_color;
      return false;
    });

    var concat_text = newcolor + " / " + opt_size;
    $(".cstm_pro_var--id").each(function () {
      var variant_option = $(this).attr("variant_att");

      if (variant_option == concat_text) {
        $(this).removeClass("hide-outofstock").addClass("showproduct");
      } else {
        $(this).addClass("hide-outofstock").removeClass("showproduct");
      }
    });
  });
  // for sale swatches
  $(".for__sale--jtpl").addClass("cstm_text_jtpl_new");
  $(".swatches.for__sale--jtpl").hide();
  $(".product-single__variants option").each(function () {
    var cp = $(this).attr("data-price-variant");
    var vp = $(this).attr("variant_price");

    if (parseInt(cp) > parseInt(vp)) {
      $(".cstm_forsale--jtpl").show();
      var cstm_text = $(this).text();

      var newText = cstm_text.substring(0, cstm_text.indexOf("/")).trim();
      $(".swatches.notfor__sale--jtpl label").each(function () {
        var swatch_color = $(this).attr("data-swatch");

        if (swatch_color == newText) {
          $(this).parent(".notfor__sale--jtpl").hide().addClass("cstmsalecls");
          $(".cstmsalecls").remove();
        }
      });
      $(".swatches.for__sale--jtpl label").each(function () {
        var swatch_color = $(this).attr("data-swatch");

        if (swatch_color == newText) {
          $(this)
            .closest(".for__sale--jtpl")
            .removeClass("cstm_text_jtpl_new")
            .addClass("cstmtxtcls")
            .show();
          $(".cstm_text_jtpl_new").hide();
        }
      });
    }
  });

  var count = $(".radio__button").length;

  $(".swatches.swatch__button").each(function () {
    var neetext = $(this).find("label").attr("data-swatch");

    var disabledOptionCount = 0;

    $(".product-single__variants option").each(function () {
      var cstm_text1 = $(this).text();

      var newText1 = cstm_text1.substring(0, cstm_text1.indexOf("/")).trim();

      if (neetext === newText1) {
        if ($(this).is(":disabled")) {
          disabledOptionCount++;
        }
      }
    });

    var dividedCount = disabledOptionCount / 2;

    if (dividedCount == count) {
      $(this).addClass("highestClass");
    }
  });
  $(".highestClass").remove();

  $(".cstmtxtcls").click(function () {
    var colourtext = $(this).find("label").attr("data-swatch");

    $(this).find(".radio__legend__value").append(colourtext);
    $(".cstm_notforsale--jtpl").find(".radio__legend__value").hide();
    $(".cstm_forsale--jtpl").find(".radio__legend__value").show();
    $(this)
      .parents(".cstm_forsale--jtpl")
      .find(".cstm_forsale--jtplvalue")
      .text(colourtext);

    var $thirdElement = $(".radio__legend__value:eq(2)");

    if ($thirdElement.length > 0) {
      $thirdElement.show();
    }
  });
  $(".notfor__sale--jtpl").click(function name(params) {
    $(".cstm_forsale--jtpl").find(".radio__legend__value").hide();
    $(".cstm_notforsale--jtpl").find(".radio__legend__value").show();
    var $thirdElement = $(".radio__legend__value:eq(2)");

    if ($thirdElement.length > 0) {
      $thirdElement.show();
    }
  });
  var $thirdElement = $(".radio__legend__value:eq(2)");

  if ($thirdElement.length > 0) {
    $thirdElement.show();
  }

  $(".cstm_forsale--jtpl").find(".radio__legend__value").hide();
  $(".cstm_notforsale--jtpl").find(".radio__legend__value").hide();

  var shouldExecuteLastCondition = false;

  $(".cstmtxtcls").each(function () {
    if (!shouldExecuteLastCondition) {
      if ($(this).find("input:checked").length > 0) {
        $(".cstm_forsale--jtpl").find(".radio__legend__value").show();
        $(".cstm_notforsale--jtpl .radio__legend__value").hide();
        shouldExecuteLastCondition = true;
      } else {
        $(".cstm_forsale--jtpl").find(".radio__legend__value").hide();
        $(".cstm_notforsale--jtpl .radio__legend__value").show();
      }
    }
    return !shouldExecuteLastCondition;
  });

  if (shouldExecuteLastCondition) {
    $(".cstm_forsale--jtpl").find(".radio__legend__value").show();
    $(".cstm_notforsale--jtpl .radio__legend__value").hide();
    var $thirdElement = $(".radio__legend__value:eq(2)");
    if ($thirdElement.length > 0) {
      $thirdElement.show();
    }
  } else {
    $(".cstm_forsale--jtpl").find(".radio__legend__value").hide();

    var $thirdElement = $(".radio__legend__value:eq(2)");
    if ($thirdElement.length > 0) {
      $thirdElement.show();
    }

    if ($(".first_color_swatch--jtpl").find(".radio__button").length >= 1) {
      $(".first_color_swatch--jtpl").show();
    }
    setTimeout(function () {
      if ($(".first_color_swatch--jtpl").find(".radio__button").length >= 1) {
        $(".first_color_swatch--jtpl").show();
      }
    }, 500);
  }

  var totallength = $(".first_color_swatch--jtpl .notfor__sale--jtpl").length;
  if (parseInt(totallength) < 1) {
    $(".first_color_swatch--jtpl:first").hide();
    $(".radio__fieldset.cstm_notforsale--jtpl").show();
    $(".cstm_forsale--jtpl").find(".radio__legend__value").show();
  }

  var gteColorname = $("small.radio__legend__value:first").text();
  $(`radio-swatch.swatches label[data-swatch="${gteColorname}"]`).addClass(
    "is-label-active"
  );
  $(".swatches.notfor__sale--jtpl").click(function () {
    $("label").removeClass("is-label-active");
  });
  $(".swatches").click(function () {
    $("label").removeClass("is-label-active");
  });

  //for custom tab content on pdp
  $(".tab__trigger").click(function () {
    $(".tab__trigger").removeClass("tab__trigger--active");
    $(this).addClass("tab__trigger--active");
    var custommtxt = $(this).attr("aria-controls");

    $(".tab__content").each(function () {
      var neetext = $(this).attr("id");
      if (custommtxt == neetext) {
        $(".tab__content").removeClass("tab__content--active");
        $(this).addClass("tab__content--active");
      }
    });
  });
  //for mobile

  $(".product-collapsible-trigger")
    .find(".collapsible-trigger__icon--close")
    .hide();

  $(".product-collapsible-trigger").on("click", function () {
    var custommtxt = $(this).attr("aria-controls");

    if ($(this).hasClass("product-collapsible-trigger--active")) {
      $(this).removeClass("product-collapsible-trigger--active");
      $("#" + custommtxt).removeClass("tab__content--active");
      $(this).find(".collapsible-trigger__icon--close").hide();
      $(this).find(".collapsible-trigger__icon--open").show();
    } else {
      $(this).find(".collapsible-trigger__icon--close").show();
      $(this).find(".collapsible-trigger__icon--open").hide();

      $(this).addClass("product-collapsible-trigger--active");

      $("#" + custommtxt).addClass("tab__content--active");
    }
  });

  //tab content
  $(".tab__content").removeClass("tab__content--active");
  var viewportWidth = window.innerWidth;

  if (viewportWidth >= 768) {
    $(".tab__content:first").addClass("tab__content--active");
  }

  var xtext = $(".is-label-active").attr("data-swatch");
  var ytext = $(".radio__button input:checked").val();
  var xyconcat = xtext + " / " + ytext;

  $(".product-single__variants option").each(function () {
    var optionText = $(this).text();
    if (xyconcat == optionText) {
      var cp_price = $(this).attr("data-price-variant");
      var vp_price = $(this).attr("variant_price");
      if (parseInt(cp_price) > parseInt(vp_price)) {
        var discunt_money = $(".add_disc_text").attr("attr-price");
        var disper = (cp_price - vp_price) / cp_price;
        var addDisPer = vp_price - (vp_price * discunt_money) / 100;
        addDisPer = addDisPer.toFixed(2);

        var addtext = $(".add_dis_txt-jtpl").text();

        $(".cstm_textt--jtpl").text("$" + addDisPer / 100 + addtext);
        $(".cstm_textt--jtpl").show();
      } else {
        $(".cstm_textt--jtpl").hide();
      }
    }
  });

  $(".swatches").click(function () {

    $(".swatches").find("label").removeClass("cstm_textfordis--jtpl");
    $(this).find("label").addClass("cstm_textfordis--jtpl");

    var xtext = $(this).find("label").attr("data-swatch");
    var ytext = $(".radio__button input:checked").val();
    var xyconcat = xtext + " / " + ytext;
    $(".product-single__variants option").each(function () {
      var optionText = $(this).text();
      if (xyconcat == optionText) {
        var cp_price = $(this).attr("data-price-variant");
        var vp_price = $(this).attr("variant_price");
        if (parseInt(cp_price) > parseInt(vp_price)) {
          var discunt_money = $(".add_disc_text").attr("attr-price");
          var disper = (cp_price - vp_price) / cp_price;
          var addDisPer = vp_price - (vp_price * discunt_money) / 100;
          var addtext = $(".add_dis_txt-jtpl").text();
          addDisPer = addDisPer.toFixed(2);
          $(".cstm_textt--jtpl").text("$" + addDisPer / 100 + addtext);
          $(".cstm_textt--jtpl").show();
        } else {
          $(".cstm_textt--jtpl").hide();
        }
      }
    });
    setTimeout(function () {
      initializeProductSlider();
    }, 1000);
    setTimeout(function () {
      slickArrowShow();
      $(".notavailable:visible").each(function () {
        if ($(this).hasClass("showproduct")) {
          $(".cstm_textt--jtpl").hide();
        }
      });
    }, 1100);
  });

  $(".radio__button").click(function () {
    var xtext = $(".cstm_textfordis--jtpl").attr("data-swatch");
    var ytext = $(this).find("input").val();
    var xyconcat = xtext + " / " + ytext;
    $(".product-single__variants option").each(function () {
      var optionText = $(this).text();
      if (xyconcat == optionText) {
        var cp_price = $(this).attr("data-price-variant");
        var vp_price = $(this).attr("variant_price");
        if (parseInt(cp_price) > parseInt(vp_price)) {
          var discunt_money = $(".add_disc_text").attr("attr-price");

          var disper = (cp_price - vp_price) / cp_price;
          var addDisPer = vp_price - (vp_price * discunt_money) / 100;
          var addtext = $(".add_dis_txt-jtpl").text();
          addDisPer = addDisPer.toFixed(2);
          $(".cstm_textt--jtpl").text("$" + addDisPer / 100 + addtext);
          $(".cstm_textt--jtpl").show();
        }
      }
    });
    setTimeout(function () {
      $(".notavailable:visible").each(function () {
        if ($(this).hasClass("showproduct")) {
          $(".cstm_textt--jtpl").hide();
        }
      });
    }, 1100);
  });
  function slickArrowShow() {
    setTimeout(function () {
      if (
        $(".product__thumbs")
          .find(".slick-slide")
          .eq(0)
          .hasClass("slick-active")
      ) {
        $(".slide-arrow.prev-arrow").hide();
      }
      $(".product__thumbs .slick-arrow").click(function () {
        var totalLength = $(".slick-slide").length;
        if (
          $(".slick-slide")
            .eq(totalLength - 1)
            .hasClass("slick-active")
        ) {
          $(".slide-arrow.next-arrow").hide();
        } else {
          $(".slide-arrow.next-arrow").show();
        }
        if ($(".slick-slide").eq(0).hasClass("slick-active")) {
          $(".slide-arrow.prev-arrow").hide();
        } else {
          $(".slide-arrow.prev-arrow").show();
        }
      });
    }, 1100);
  }
  slickArrowShow();

  $(".cstm-grid-slider").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    prevArrow:
      '<button class="slide-arrow cstm-prev-arrow"><img style="display: block;-webkit-user-select: none;margin: auto;" src="https://www.lysse.com/cdn/shop/t/230/assets/left_arrow.png"></button>',
    nextArrow:
      '<button class="slide-arrow cstm-next-arrow"><img style="display: block;-webkit-user-select: none;margin: auto;" src="https://www.lysse.com/cdn/shop/t/230/assets/right_arrow.png"></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 468,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".radio__button").click(function () {
    var radio_text = $(this).find("input").attr("value");
    $(this)
      .parents(".radio__fieldset")
      .find(".radio__legend__value")
      .text(radio_text);
  });

  var radio_data = $(".radio__button").find("input:checked").attr("value");
  function radioSwacthHide() {
    $(".include_spo").each(function () {
      var include_spo = $(this).attr("option_title") || "";
      include_spo = include_spo.split(" / ")[1].trim();
      var include_spo_size = $(this).attr("option_title") || "";
      include_spo_size = include_spo_size.split(" / ")[0].trim().toLowerCase();
      if (include_spo == radio_data) {
        $(".cstmtxtcls").each(function () {
          var inc = $(this).find("label").attr("data-swatch") || "";
          inc = inc.split(" / ")[0].trim().toLowerCase();
          if (include_spo_size === inc) {
            $(this).hide();
          } else {
          }
        });
        $(".notfor__sale--jtpl").each(function () {
          var inc = $(this).find("label").attr("data-swatch") || "";
          inc = inc.split(" / ")[0].trim().toLowerCase();
          if (include_spo_size === inc) {
            $(this).hide();
          } else {
          }
        });
      }
    });
    var cstmtotallength = $(".cstmtxtcls").length;
    var hiddenCount = $(".cstmtxtcls:hidden").length;
    if (cstmtotallength == hiddenCount) {
      $(".cstmtxtcls").parents(".cstm_forsale--jtpl").hide();
    } else {
      $(".cstmtxtcls").parents(".cstm_forsale--jtpl").show();
    }

    var cstmsale = $(".notfor__sale--jtpl").length;
    var cstmsalehide = $(".notfor__sale--jtpl:hidden").length;
    if (cstmsale == cstmsalehide) {
      $(".notfor__sale--jtpl").parents(".cstm_notforsale--jtpl").hide();
    } else {
      $(".notfor__sale--jtpl").parents(".cstm_notforsale--jtpl").show();
    }
  }

  radioSwacthHide();
  $(".radio__button").click(function () {
    $(".cstmtxtcls").parents(".cstm_forsale--jtpl").show();

    $("button[type=submit]").removeAttr("disabled", "true");

    var radio_data1 = $(this).find("input").attr("value");
    $(".cstmtxtcls").show();
    $(".notfor__sale--jtpl").show();

    $(".include_spo").each(function () {
      var include_spo = $(this).attr("option_title") || "";
      include_spo = include_spo.split(" / ")[1].trim();
      var include_spo_size = $(this).attr("option_title") || "";
      include_spo_size = include_spo_size.split(" / ")[0].trim().toLowerCase();
      if (include_spo == radio_data1) {
        $(".cstmtxtcls").each(function () {
          var inc = $(this).find("label").attr("data-swatch") || "";
          inc = inc.split(" / ")[0].trim().toLowerCase();
          if (include_spo_size === inc) {
            $(this).hide();
            setTimeout(function () {
              
            }, 1000);
          } else {
          }
        });
        $(".notfor__sale--jtpl").each(function () {
          var inc = $(this).find("label").attr("data-swatch") || "";
          inc = inc.split(" / ")[0].trim().toLowerCase();
          if (include_spo_size === inc) {
            $(this).hide();
          } else {
          }
        });
        $(".radio-legend-swatch").each(function () {
          if ($(this).css("display") === "none") {
          } else {
            var legend_text = $(this).text();
            legend_text = legend_text.toLowerCase();
           
            if (legend_text == include_spo_size) {
              setTimeout(function () {
                $("button[type=submit]").attr("disabled", "true");
              }, 400);
              return;
            } else {
            }
          }
        });
      }
    });

    var cstmtotallength = $(".cstmtxtcls").length;
    var hiddenCount = $(".cstmtxtcls:hidden").length;
    if (cstmtotallength == hiddenCount) {
      $(".cstmtxtcls").parents(".cstm_forsale--jtpl").hide();
    } else {
      $(".cstmtxtcls").parents(".cstm_forsale--jtpl").show();
    }
  });

  $(".cstmtxtcls").parents(".cstm_forsale--jtpl").show();

  $("button[type=submit]").removeAttr("disabled", "true");

  var radio_data1 = $(".radio__legend__value:last").text();

  $(".cstmtxtcls").show();
  $(".notfor__sale--jtpl").show();

  $(".include_spo").each(function () {
    var include_spo = $(this).attr("option_title") || "";
    include_spo = include_spo.split(" / ")[1].trim();
    var include_spo_size = $(this).attr("option_title") || "";
    include_spo_size = include_spo_size.split(" / ")[0].trim().toLowerCase();
    if (include_spo == radio_data1) {
      $(".cstmtxtcls").each(function () {
        var inc = $(this).find("label").attr("data-swatch") || "";
        inc = inc.split(" / ")[0].trim().toLowerCase();
        if (include_spo_size === inc) {
          $(this).hide();
          setTimeout(function () {}, 1000);
        } else {
        }
      });
      $(".notfor__sale--jtpl").each(function () {
        var inc = $(this).find("label").attr("data-swatch") || "";
        inc = inc.split(" / ")[0].trim().toLowerCase();
        if (include_spo_size === inc) {
          $(this).hide();
        } else {
        }
      });
      $(".radio-legend-swatch").each(function () {
        if ($(this).css("display") === "none") {
        } else {
          var legend_text = $(this).text();
          legend_text = legend_text.toLowerCase();
          if (legend_text == include_spo_size) {
            setTimeout(function () {
              $("button[type=submit]").attr("disabled", "true");
            }, 400);
            return;
          } else {
          }
        }
      });
    }
  });

  var cstmtotallength = $(".cstmtxtcls").length;
  var hiddenCount = $(".cstmtxtcls:hidden").length;
  if (cstmtotallength == hiddenCount) {
    $(".cstmtxtcls").parents(".cstm_forsale--jtpl").hide();
  } else {
    $(".cstmtxtcls").parents(".cstm_forsale--jtpl").show();
  }

  $(".swatch__button").click(function () {
    $(".radio__button").show();
    var matchText = $(this).find("label").attr("data-swatch");
    matchText = matchText.split(" / ")[0].trim().toLowerCase();

    $(".include_spo").each(function () {
      var include_spo = $(this).attr("option_title") || "";
      include_spo = include_spo.split(" / ")[1]?.trim() || "";

      var include_spo_size = $(this).attr("option_title") || "";
      include_spo_size = include_spo_size.split(" / ")[0].trim().toLowerCase();

      if (matchText === include_spo_size) {
        $(".radio__button").each(function () {
          var radioText = $(this).find("input").attr("value");

          if (radioText == include_spo) {
            $(this).hide();
          }
        });
      }
    });
  });

  ///for final text js
  setTimeout(function () {
    var visibleswatchelement = $(".radio-legend-swatch:visible").eq(0).text();
    var visibleradio = $(".radio__button input:checked").attr("value");
    try {
      var tags = $(".finalsaletags").data("tag");
      var finaltext = $(".radio-legend-swatch:visible").eq(0).text();
      var new_final_text = visibleswatchelement + " / " + visibleradio;
      var matchid = $(".product-single__variants option")
        .filter(function () {
          return $(this).attr("option_title") === new_final_text;
        })
        .attr("value");
      var n = tags.indexOf(matchid + "-final-sale");
      if (n > 0) {
        $(".finalsaletags").show();
        $("p.line-item-property__field").append(
          '<input class="cstm-final-sale-line aa" type="text" name="properties[Final Sale]" value="Final Sale">'
        );
      } else {
        $(".finalsaletags").hide();
        $("p.line-item-property__field").empty();
      }
    } catch (error) {
    }
  }, 600);
  $(".radio__button").click(function () {
    var selected_element = $(this).find(".option-title").text();

    setTimeout(function () {
      try {
        var tags = $(".finalsaletags").data("tag");
        var finaltext = $(".radio-legend-swatch:visible").eq(0).text();

        var new_final_text = finaltext + " / " + selected_element;
        var matchid = $(".product-single__variants option")
          .filter(function () {
            return $(this).attr("option_title") === new_final_text;
          })
          .attr("value");

        var n = tags.indexOf(matchid + "-final-sale");
        if (n > 0) {
          $(".finalsaletags").show();
          $("p.line-item-property__field").append(
            '<input class="cstm-final-sale-line bb" type="text" name="properties[Final Sale]" value="Final Sale">'
          );
        } else {
          $(".finalsaletags").hide();
          $("p.line-item-property__field").empty();
        }
      } catch (error) {
      }
    }, 600);
    if ($(".all-sale-final").length > 0) {
      $("p.line-item-property__field").append(
        '<input class="cstm-final-sale-line cc" type="text" name="properties[Final Sale]" value="Final Sale">'
      );
      $(".finalsaletags").hide();
      setTimeout(function () {
        $("p.line-item-property__field").append(
          '<input class="cstm-final-sale-line dd" type="text" name="properties[Final Sale]" value="Final Sale">'
        );
        $(".finalsaletags").hide();
      }, 650);
    }
  });
  $(".swatch__button label").click(function () {
    var selected_element = $(".radio__button input:checked").attr("value");

    setTimeout(function () {
      try {
        var tags = $(".finalsaletags").data("tag");
        var finaltext = $(".radio-legend-swatch:visible").eq(0).text();
        var new_final_text = finaltext + " / " + selected_element;
        var matchid = $(".product-single__variants option")
          .filter(function () {
            return $(this).attr("option_title") === new_final_text;
          })
          .attr("value");
        var n = tags.indexOf(matchid + "-final-sale");

        if (n > 0) {
          $(".finalsaletags").show();
          $("p.line-item-property__field").append(
            '<input class="cstm-final-sale-line ee" type="text" name="properties[Final Sale]" value="Final Sale">'
          );
        } else {
          $(".finalsaletags").hide();
          $("p.line-item-property__field").empty();
        }
      } catch (error) {
      }
    }, 600);
    if ($(".all-sale-final").length > 0) {
      $("p.line-item-property__field").append(
        '<input class="cstm-final-sale-line ff" type="text" name="properties[Final Sale]" value="Final Sale">'
      );
      $(".finalsaletags").hide();
      setTimeout(function () {
        $("p.line-item-property__field").append(
          '<input class="cstm-final-sale-line gg" type="text" name="properties[Final Sale]" value="Final Sale">'
        );
        $(".finalsaletags").hide();
      }, 650);
    }
  });

  if ($(".all-sale-final").length > 0) {
    $("p.line-item-property__field").append(
      '<input class="cstm-final-sale-line hh" type="text" name="properties[Final Sale]" value="Final Sale">'
    );
    $(".finalsaletags").hide();
    setTimeout(function () {
      $("p.line-item-property__field").append(
        '<input class="cstm-final-sale-line ii" type="text" name="properties[Final Sale]" value="Final Sale">'
      );
      $(".finalsaletags").hide();
    }, 650);
  }
});
//back in stock

var proid = "";
$(document).ready(function () {
  $(".size__option-value").click(function () {
    $(".default_msg").hide();
  });

  $("label ").click(function () {

    var url = document.URL;
    $.urlParam = function (name) {
      var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
        window.location.href
      );

      if (results == null || results[1] == null) {
        var proidd = parseInt($(".cstm-product-form-id").val());

        return proidd;
      } else {
        return results[1] || 0;
      }
    };
    proid = $.urlParam("variant");
    $(".formm .product-variant-id").hide();
    $(".fordd .product-variant-id").hide();
    setTimeout(function () {
      proid = $.urlParam("variant");
      try {
        var tags = $(".finalsaletags").data("tag");
        var n = tags.indexOf(proid + "-final-sale");
        if (n > 0) {
          $(".finalsaletags").show();
        } else {
          $(".finalsaletags").hide();
        }
      } catch (error) {
        // expected output: ReferenceError: nonExistentFunction is not defined
        // Note - error messages will vary depending on browser
      }

      $(".formm #product-variant-id-" + proid).show();
      $(".fordd #product-variant-id-" + proid).show();
      $(".product-shop-back-in-stock-submit").attr("data-variant-id", proid);
      $(".js-product-back-in-stock-submit").text("Notify Me");
      $(".js-product-back-in-stock-submit").attr("data-variant-id", proid);
    }, 600);
  });
});
/* =========================================================================
    Back in Stock App
========================================================================= */
window.onclick = function (c) {
  if (c.srcElement != null)
    "product-shop-back-in-stock-email" == c.srcElement.className &&
      c.srcElement.classList.add("currentFieldzx");
};
$(document).on("click", ".js-product-back-in-stock-submit", function () {
  var a = $(this);
  if (a.parents(".product-shop-submit").hasClass("is_stuck"))
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600,
      "easeOutExpo"
    );
  else {
    var t = a.attr("data-product-id"),
      r = a.attr("data-variant-id"),
      i = $(".product-shop-back-in-stock-email.currentFieldzx").val();
    BIS.create(i, r, t).then(function (t) {
      var r = "";
      if ("OK" == t.status) r = "Thank you!";
      else {
        var i = "";
        for (var e in t.errors) i += e + " " + t.errors[e].join();
        r =
          i.indexOf("already") >= 0
            ? "Thank you!"
            : i.indexOf("invalid") >= 0
            ? "invalid email"
            : "error";
      }
      a.text(r);
    });
  }
});
$(document).on("click", ".product-shop-back-in-stock-submit", function () {
  var a = $(".product-shop-back-in-stock-email"),
    t = $(".product-shop-back-in-stock-submit"),
    r = a.val(),
    i = t.attr("data-product-id"),
    o = t.attr("data-variant-id");
  BIS.create(r, o, i).then(function (a) {
    var r = "";
    if ("OK" == a.status) r = "Thank you!";
    else {
      var i = "";
      for (var o in a.errors) i += o + " " + a.errors[o].join();
      r =
        i.indexOf("already") >= 0
          ? "Thank you!"
          : i.indexOf("invalid") >= 0
          ? "invalid email"
          : "error";
    }
    t.text(r);
  });
});
